import _extends from '@babel/runtime/helpers/extends';
import { DROPDOWN_VARIANT } from './constants.js';
export { DROPDOWN_VARIANT } from './constants.js';
import Dropdown$1 from './Dropdown.js';

var Dropdown = _extends(Dropdown$1, {
  VARIANT: DROPDOWN_VARIANT
});

export { Dropdown as default };
